import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'uni-end-of-day-manager',
  standalone: false,
  templateUrl: './end-of-day-manager.component.html',
})
export class EndOfDayManagerComponent {
  isSidebarCollapsed = false;

  toggleSidebar(): void {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  items: MenuItem[] = [
    {
      label: '<span class="text-l font-bold">End of Day</span>',
      escape: false,
      expanded: true,
      items: [
        {
          label: 'Print/Post Invoices',
          icon: 'pi pi-fw pi-file-export',
          routerLink: ['/end-of-day/manage/invoices'],
        },
        {
          label: 'Account-Owned Invoices',
          icon: 'pi pi-fw pi-wallet',
          routerLink: ['/end-of-day/manage/acct-owned-invoices'],
        },
        {
          label: 'Manifest Groups',
          icon: 'pi pi-fw pi-list',
          routerLink: ['/end-of-day/manage/manifests'],
        },
      ],
    },
    {
      label: '<span class="text-l font-bold">Documentation</span>',
      escape: false,
      expanded: false,
      items: [
        {
          label: 'End of Day Workflow',
          icon: 'pi pi-fw pi-book',
          routerLink: ['/end-of-day/manage/documentation'],
        },
      ],
    },
  ];
}
